export default "__VITE_ASSET__wQ1ComV5__"